const Culture = (
    <div className='md:w-4/5 mx-auto py-10 text-lg'>
        <h1 className='text-2xl font-bold'>Culture</h1>
        <br />
        <p className="text-gray-500">
            This is something that you cannot implement. First, you should start with people
            having a proper mindset that concerns all team members. Everyone should be
            focused on a common goal and help others achieve it whether it’s within your
            specialization area or not. Stepping out of your comfort zone and leaning towards
            becoming a full-stack engineer is encouraged.
        </p>
    </div>
)
export default Culture